<template>

  <v-layout>
    <v-flex v-if="reportsPending">
      <v-flex>
        Getting geo report...
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-flex>
    <v-flex v-else>
      <v-layout column full-width>
        <!-- <ClientTimeOrderedTile :hide-title='true' layout='bar' button-text="Reload Report"/>
        -->

        <!--
        <v-layout row justify-end align-center class="mb-2">
          <v-flex shrink>
            <v-btn disabled @click="csvExport" color="primary" :disabled="loadingCsv" :loading="loadingCsv">
              <v-icon left small>
                save_alt
              </v-icon>
              Export
            </v-btn>
          </v-flex>
        </v-layout>
        -->

        <v-card>
          <v-card-title>
            <v-layout row>
              <h1 class="subheading-1">Geo Report</h1>
            </v-layout>
            <v-layout row>
              <v-flex class="mr-2">
                <v-autocomplete
                  label="States"
                  :items="stateTags"
                  item-text="name"
                  item-value="id"
                  @change="updateReport($event)"
                />
              </v-flex>

              <v-flex>
                <v-autocomplete
                  label="Regions"
                  :items="regionTags"
                  item-text="name"
                  item-value="id"
                  @change="updateReport($event)"
                />
              </v-flex>
            </v-layout>
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="a in report.segments" :key="a.id">
                {{ a.name }}.
                Total: {{ a.worksites.map(w => w.shifts).flat().reduce((p, c) => { return (p + parseFloat(c.hoursWorked)) }, 0) }}
                <ul>
                  <li v-for="w in a.worksites" :key="w.id">
                    {{ w.name }}. Total: {{ w.shifts.reduce((p, c) => { return (p + parseFloat(c.hoursWorked)) }, 0) }}
                    <ul>
                      <li v-if="i < 5" v-for="(s, i) in w.shifts" :key="s.id">
                        employee: {{ s.workerName }}, hours: {{ s.hoursWorked }}
                      </li>
                      <li>...</li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </v-card-text>

          <pre v-if="false">
            {{ report }}
          </pre>

        </v-card>
      </v-layout>

    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ExportToCsv } from 'export-to-csv';
import ClientTimeOrderedTile from '@/components/reports/client-time-ordered-tile.vue'
import reports from '@/api/reports';

export default {
  components: {
    ClientTimeOrderedTile
  },
  props: ['tagIDs'],
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    ...mapState("geotags", ["geotags"]),
    ...mapGetters("geotags", ["stateTags", "regionTags", "defaultTags"]),
    //computedOffset: function () {
    //  return this.limit * (this.page - 1)
    //},
    //pageLength: function () {
    //  return Math.ceil(this.queryTotal / this.limit)
    //},
    formattedQuery: function () {
      return {
        startDate: this.startDate,
        endDate: this.endDate,
        selectedClientId: this.selectedClientId,
        timePeriod: this.timePeriod,
      }
    },
    timePeriodMap: function () {
      if (!this.report) {
        return []
      }
      return this.report.byTimePeriod
    },

    totalMap: function () {
      if (!this.report) {
        return []
      }
      return this.report.totals
    },
  },
  created () {
    this.$store.dispatch("geotags/getAll");
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      report: {},
      startDate : '',
      endDate : '',
      reportsPending: true,
      loadingCsv: false,
      report: null,
    }
  },

  methods: {
    updateReport(tagID) {
      this.$router.push({
        name: 'geoReport',
        params: {
          tagIDs: tagID,
        }
      })
    },

    setUp: function () {
      this.startDate = this.$route.query.startDate || this.startDate
      this.endDate = this.$route.query.endDate || this.endDate

      this.getReports()
    },

    generateCsv: function (report) {
      const options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true, 
        showTitle: false,
        filename: `time-ordered_${ report.clientBusiness.name }_${ this.$moment(this.startDate).format('YYYY') }--${ this.$moment(this.endDate).format('YYYY') }`,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
      };

      const exportedFormat = report.report.byTimePeriod.map(r => {
        const row = {}

        row['Time Period'] = r.time_period
        row['Position'] = r.position_name
        row['Shifts Ordered'] = r.shifts_ordered
        row['Shifts Fulfilled'] = r.shifts_fulfilled
        row['Shift Fulfillment Percent'] = r.shift_fulfillment_percent
        row['Hours Ordered'] = r.hours_ordered
        row['Hours Fulfilled'] = r.hours_fulfilled
        row['Hours Fulfillment Percent'] = r.hours_fulfillment_percent

        return row
      })

      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(exportedFormat);
      this.loadingCsv = false
    },

    round: function(hours) {
      return Math.round(hours * 100) / 100
    },

    csvExport: function () {
      this.loadingCsv = true
      this.$store.dispatch('reports/getClientTimeOrdered', this.formattedQuery)
      .then(report => {
        this.generateCsv(report)
      }).catch(err => {
        console.log(err)
      }).finally(res => {
        this.loadingCsv = false
      })
    },

    dateFormatted: function (date) {
      return date ? this.$moment(date).format('dddd, MMMM D') : ''
    },

    getReports: function () {
      const params = {
        tagIDs: this.tagIDs
      }
      reports.getGeoReport(params,

      (r) => {
        console.log('r ', r)
        this.report = r
        this.reportsPending = false
      },
      (err) => {
        console.log('e ', err)
        this.reportsPending = false
      })
    },
  },
}
</script>

<style scoped>
  table.ordered-time, table.ordered-time th, table.ordered-time td {
    border: 1px solid black;
    border-collapse: collapse;
  }
  table.ordered-time th, table.ordered-time td {
    padding: 1em 2em;
  }
</style>
